import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { PromoProductFamily } from 'src/app/assabil-sales/models/entities/promo-product-family.entity';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';


@Component({
  selector: 'promo-product-family-list',
  templateUrl: './promo-product-family-list.component.html',
  styleUrls: ['./promo-product-family-list.component.scss']
})

export class PromoProductFamilyListComponent extends BasePage2<PromoProductFamily> {

  promoProductFamilies  : PromoProductFamily[] = [];
  codeFilter            : string;
  nameFilter            : string;

  constructor(   
    protected toastr            : ToastrService,
    protected router            : Router,
    protected promoService      : PromoService,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService,
    protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'promoProductFamily';
  }



  initEntityContainer() {
  }

  selectRow(promoProductFamily : PromoProductFamily){
    this.promoService.promoProductFamilyGet(promoProductFamily.promoProductFamilyCode).then(promoProductFamily => {
      this.selectedRow = promoProductFamily;
    });
  }

  getRows(): PromoProductFamily[] {
      return this.promoProductFamilies;
  }

  saveRow(row: PromoProductFamily): Promise<PromoProductFamily> {
    //  return this.promoService.promoProductFamilySave(row);
    throw new Error("Method not implemented.");
  }


  loadData(){
    this.promoService.promoProductFamiliesGet(this.codeFilter, this.nameFilter).then(promoProductFamilies => {
      this.promoProductFamilies = promoProductFamilies;
    });
  }

  newPromoProductFamily(){
    let promoProductFamily = new PromoProductFamily();
    promoProductFamily.inserted = true;
    promoProductFamily.edit     = true;
    this.selectedRow = promoProductFamily;
  }


}
